export type ValidationCode =
  | 'required'
  | 'not_a_string'
  | 'not_a_number'
  | 'not_an_integer'
  | 'not_finite'
  | 'not_an_object'
  | 'not_an_array'
  | 'literal_mismatch'
  | 'not_in_enum'
  | 'too_short'
  | 'too_long'
  | 'below_min'
  | 'above_max'
  | 'failed_refinement';

export interface ValidationError {
  readonly path: string;
  readonly code: ValidationCode;
  readonly message: string;
}

export function makeError(
  path: string,
  code: ValidationCode,
  message: string,
): ValidationError {
  return { path, code, message };
}
